module.exports = __webpack_public_path__ + "img/superiority4.175ac50.png";